/**
 * @copyright © Paramount Streaming
 * @author Daniel Silva
 * @description Public Skin control identifiers supported by the page-driven controls API
 */
export enum SkinControl {
	RESTART = 'restart'
}